var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 151,
    viewBox: "0 0 137 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 150.022C0 112.444 30.4667 82 68.0222 82C105.578 82 136.044 112.467 136.044 150.022",
    fill: "url(#paint0_linear_10391_22656)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.688 31.7959L71.2363 17.0728L39.3221 91.7501L73.7733 106.473L105.688 31.7959Z",
    fill: "url(#paint1_linear_10391_22656)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.999 26.6495L105.698 31.7623L71.2481 17.0399L69.9023 8.23024L77.1933 3.1228L111.648 17.8506L112.999 26.6495Z",
    fill: "url(#paint2_linear_10391_22656)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.206 16.8023L79.6426 4.17152L83.134 1.04761L109.05 12.1218L109.206 16.8023Z",
    fill: "url(#paint3_linear_10391_22656)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6654 115.865L65.2878 120.329L35.1782 107.461L34 99.7752L34.0595 99.7319L71.6545 115.8L71.6654 115.865Z",
    fill: "url(#paint4_linear_10391_22656)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1528 119.416L37.3184 108.374L37.4535 112.465L60.0992 122.145L63.1528 119.416Z",
    fill: "url(#paint5_linear_10391_22656)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.526 10.6084L86.6641 2.55L88.8908 0.555664L105.424 7.61961L105.526 10.6084Z",
    fill: "url(#paint6_linear_10391_22656)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.018 120.821L40.5391 113.779L40.6255 116.389L55.0723 122.561L57.018 120.821Z",
    fill: "url(#paint7_linear_10391_22656)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2959 107.118L37.3359 90.8958L34.458 97.6299L72.4179 113.853L75.2959 107.118Z",
    fill: "url(#paint8_linear_10391_22656)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8165 112.703L37.0898 98.7173L36.2551 100.67L68.9818 114.657L69.8165 112.703Z",
    fill: "url(#paint9_linear_10391_22656)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8487 18.6179L66.3147 38.5883L61.0938 40.6367L43.0312 82.896L49.6088 91.9273L48.0792 95.5052L52.1111 97.2293L54.6838 91.2193L49.1169 82.2853L65.2175 44.6037L68.7252 46.1062L76.3891 28.168L85.7392 24.4388L86.177 23.4227L74.8487 18.6179Z",
    fill: "url(#paint10_linear_10391_22656)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.947 30.195L93.4134 50.1654L95.5428 55.3593L77.4857 97.6187L66.4115 99.1104L64.882 102.688L60.8555 100.964L63.4227 94.9542L73.7241 92.7977L89.8247 55.1215L86.317 53.6244L93.9809 35.6916L90.2084 26.3523L90.6462 25.3308L101.947 30.195Z",
    fill: "url(#paint11_linear_10391_22656)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2368 58.8286C77.5859 58.9781 77.9715 59.0207 78.3448 58.9509C78.7181 58.8812 79.0623 58.7022 79.3338 58.4367C79.6053 58.1712 79.7919 57.8311 79.87 57.4595C79.9481 57.0878 79.9142 56.7014 79.7725 56.349C79.6308 55.9967 79.3877 55.6943 79.0741 55.4802C78.7604 55.2661 78.3903 55.1499 78.0106 55.1463C77.6308 55.1427 77.2586 55.2519 76.9409 55.46C76.6233 55.6681 76.3745 55.9658 76.2262 56.3154C76.1265 56.5466 76.0736 56.7953 76.0705 57.0471C76.0674 57.2989 76.1141 57.5488 76.2081 57.7825C76.302 58.0161 76.4413 58.2288 76.6179 58.4084C76.7945 58.5879 77.0048 58.7307 77.2368 58.8286Z",
    fill: "#FF7510"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3295 63.6658L73.8056 62.1687C73.611 62.0876 73.611 62.0173 73.7786 61.8876L77.3241 59.4663L73.7299 57.9314L67.5632 62.1038C67.5314 62.1314 67.5071 62.1666 67.4927 62.2062C67.4782 62.2457 67.474 62.2882 67.4805 62.3298C67.487 62.3714 67.5039 62.4107 67.5297 62.4439C67.5555 62.4772 67.5894 62.5034 67.628 62.52L70.4763 63.736C70.6709 63.8225 70.7033 63.9036 70.5358 64.0279L63.1854 68.9246C63.1829 68.937 63.1829 68.9499 63.1854 68.9624C63.1804 68.9782 63.1804 68.9952 63.1854 69.011C63.1877 69.0187 63.1919 69.0256 63.1975 69.0313C63.2032 69.037 63.2101 69.0411 63.2178 69.0435C63.2336 69.0488 63.2507 69.0488 63.2664 69.0435L77.3187 63.9901C77.3508 63.9784 77.379 63.9578 77.3997 63.9306C77.4224 63.903 77.4356 63.869 77.4376 63.8333C77.437 63.7974 77.4277 63.7622 77.4105 63.7306C77.3901 63.7019 77.362 63.6794 77.3295 63.6658Z",
    fill: "#FF7510"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10391_22656",
    x1: 68.466,
    y1: 127.864,
    x2: 69.3746,
    y2: 82.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C253D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#26304B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10391_22656",
    x1: 50.7488,
    y1: 52.4694,
    x2: 107.058,
    y2: 76.5336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#252F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10391_22656",
    x1: 68.1911,
    y1: 7.50494,
    x2: 99.8642,
    y2: 21.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10391_22656",
    x1: 78.1907,
    y1: 1.24555,
    x2: 101.012,
    y2: 10.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10391_22656",
    x1: 32.7067,
    y1: 102.779,
    x2: 70.3684,
    y2: 118.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10391_22656",
    x1: 36.7999,
    y1: 109.983,
    x2: 62.646,
    y2: 120.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10391_22656",
    x1: 87.1951,
    y1: 1.30222,
    x2: 106.056,
    y2: 9.36255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10391_22656",
    x1: 41.4051,
    y1: 114.921,
    x2: 57.8983,
    y2: 121.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10391_22656",
    x1: 35.898,
    y1: 94.2604,
    x2: 73.858,
    y2: 110.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10391_22656",
    x1: 28.2993,
    y1: 96.1126,
    x2: 61.0259,
    y2: 110.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10391_22656",
    x1: 71.68,
    y1: 61.4115,
    x2: 45.1309,
    y2: 50.0654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10391_22656",
    x1: 74.9596,
    y1: 62.8135,
    x2: 90.3563,
    y2: 69.3935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#212C46"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana);
export default __webpack_public_path__ + "static/media/mana.6edb2ba24e5202a475bcfc1dd611c9b1.svg";
export { ForwardRef as ReactComponent };